import { createAsyncThunk } from "@reduxjs/toolkit";
import { AppId, AppThunkAPIType } from "../../app/appTypes";
import { deleteWithAuth, getWithAuth, postWithAuth } from "../../http";

export interface ProjectTeamMember {
	id: AppId;
	user: string;
	firstName: string;
	lastName: string;
	isExternal?: boolean;
	position: string;
	companyName: string;
	role: string;
	projectId: number;
}

export interface CreateProjectTeamMemberPayload {
	user: string;
	projectId: string;
	role: string;
}

export interface InviteProjectTeamMemberPayload {
	userEmail: string;
	projectId: string;
	role: string;
}

export const loadProjectTeamMembers = createAsyncThunk<ProjectTeamMember[], AppId, AppThunkAPIType>(
	"project-team-member/load",
	async (projectId, { rejectWithValue, dispatch }) => {
		const result = await dispatch(getWithAuth({
			url: `api/project-team-member/${projectId}`,
		}));
		const { payload } = result;

		if (getWithAuth.fulfilled.match(result)) {
			return payload as ProjectTeamMember[];
		} else {
			return rejectWithValue(payload ?? { kind: "unknown" });
		}
	}
);

export const createProjectTeamMember = createAsyncThunk<ProjectTeamMember, CreateProjectTeamMemberPayload, AppThunkAPIType>(
	"project-team-member/create",
	async (createPayload, { rejectWithValue, dispatch }) => {
		const result = await dispatch(postWithAuth({
			url: "api/project-team-member",
			payload: createPayload,
		}));
		const { payload } = result;

		if (postWithAuth.fulfilled.match(result)) {
			return payload as ProjectTeamMember;
		} else {
			return rejectWithValue(payload ?? { kind: "unknown" });
		}
	}
);

export const inviteProjectTeamMember = createAsyncThunk<ProjectTeamMember, InviteProjectTeamMemberPayload, AppThunkAPIType>(
	"project-team-member/invite",
	async (invitePayload, { rejectWithValue, dispatch }) => {
		const result = await dispatch(postWithAuth({
			url: "api/project-team-member/invite",
			payload: invitePayload,
		}));
		const { payload } = result;

		if (postWithAuth.fulfilled.match(result)) {
			return payload as ProjectTeamMember;
		} else {
			return rejectWithValue(payload ?? { kind: "unknown" });
		}
	}
);

export const deleteProjectTeamMember = createAsyncThunk<AppId, AppId, AppThunkAPIType>(
	"project-team-member/delete",
	async (id, { rejectWithValue, dispatch }) => {
		const result = await dispatch(deleteWithAuth({ url: `api/project-team-member/${id}` }));
		const { payload } = result;

		if (deleteWithAuth.fulfilled.match(result)) {
			return id;
		} else {
			return rejectWithValue(payload ?? { kind: "unknown" });
		}
	}
);
